import type { Novidade } from './tipos';

/** Fase 2 (W29): "Enviar cobrança agora" na ficha da fatura, com a mesma mensagem da régua. */
export const novidadeEnviarCobranca: Novidade = {
  id: '2026-10-05-enviar-cobranca',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: 'contas',
  permissao: 'contas.cobrar',
  textos: {
    pt: {
      titulo: 'Enviar cobrança agora',
      resumo: 'Na ficha da fatura a receber, mande a cobrança ao cliente na hora, sem esperar a régua, com o link do Asaas.',
      passos: [
        'Abra a fatura em aberto e clique em "Enviar cobrança agora", na seção da cobrança.',
        'Confira para onde vai e escolha o canal: e-mail, WhatsApp (com o WhatsApp conectado) ou os dois.',
        'O envio aparece na ficha e na aba Cobranças como "Envio manual"; a mesma fatura só sai de novo pelo mesmo canal depois de 1 minuto.',
      ],
    },
    en: {
      titulo: 'Send charge now',
      resumo: 'On a receivable invoice, send the charge to the customer right away, without waiting for the collection schedule, with the Asaas link.',
      passos: [
        'Open the open invoice and click "Send charge now", in the charge section.',
        'Check where it goes and pick the channel: email, WhatsApp (with WhatsApp connected) or both.',
        'The send shows on the invoice and in the Collections tab as "Manual send"; the same invoice only goes out again through the same channel after 1 minute.',
      ],
    },
    es: {
      titulo: 'Enviar cobro ahora',
      resumo: 'En la factura por cobrar, envía el cobro al cliente en el momento, sin esperar la secuencia de cobranza, con el enlace de Asaas.',
      passos: [
        'Abre la factura abierta y haz clic en "Enviar cobro ahora", en la sección del cobro.',
        'Revisa a dónde va y elige el canal: correo, WhatsApp (con WhatsApp conectado) o ambos.',
        'El envío aparece en la factura y en la pestaña Cobros como "Envío manual"; la misma factura solo sale de nuevo por el mismo canal después de 1 minuto.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-enviar-cobranca/confirmacao.webp', '/novidades/2026-10-05-enviar-cobranca/enviada.webp'],
  treinamento: { curso: 'novidades' },
  rota: '/financeiro/contas/a-receber',
};
